import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../core/auth.service';

export function roleGuard(requiredRole: string): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const platformId = inject(PLATFORM_ID);

    if (isPlatformServer(platformId)) {
      return true;
    }
    if (!auth.isLoggedIn()) {
      return router.createUrlTree(['/']);
    }
    if (auth.hasRole(requiredRole)) {
      return true;
    }
    return router.createUrlTree(['/']);
  };
}
